export default __webpack_public_path__ + "static/media/exposure.0d15ed61.svg";